var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.closeModal
              }
            },
            [_vm._v(" Change Password ")]
          ),
          _c(
            "v-card-text",
            {
              staticClass: "pb-3"
            },
            [
              _c("compact-password", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  outlined: "",
                  label: "Password",
                  "data-vv-name": "password",
                  "data-vv-as": "Password",
                  "error-messages": _vm.errors.collect("password"),
                  "with-generator": ""
                },
                model: {
                  value: _vm.model.password,
                  callback: function callback($$v) {
                    _vm.$set(_vm.model, "password", $$v)
                  },
                  expression: "model.password"
                }
              })
            ],
            1
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "justify-content-end pb-4 pr-4"
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.closeModal
                  }
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    primary: "",
                    loading: _vm.query_loading
                  },
                  on: {
                    click: _vm.setPassword
                  }
                },
                [_vm._v(" Save Changes ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }